"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var size_chart_1 = require("../../shared/models/size_chart");
var GraphicComponent_1 = require("../../shared/components/GraphicComponent");
var graphics_1 = require("../../shared/util/graphics");
var lodash_find_1 = __importDefault(require("lodash.find"));
var lodash_flatmap_1 = __importDefault(require("lodash.flatmap"));
var lodash_isequal_1 = __importDefault(require("lodash.isequal"));
var Dimension_1 = require("../../shared/models/Dimension");
var large_measurements_1 = require("../../shared/util/large_measurements");
var AnnotationsDisplay;
(function (AnnotationsDisplay) {
    AnnotationsDisplay[AnnotationsDisplay["SHOW_MEASUREMENTS"] = 0] = "SHOW_MEASUREMENTS";
    AnnotationsDisplay[AnnotationsDisplay["SHOW_LABELS"] = 1] = "SHOW_LABELS";
    AnnotationsDisplay[AnnotationsDisplay["HIDE"] = 2] = "HIDE";
})(AnnotationsDisplay = exports.AnnotationsDisplay || (exports.AnnotationsDisplay = {}));
var Annotations = /** @class */ (function (_super) {
    __extends(Annotations, _super);
    function Annotations(props) {
        var _this = _super.call(this, props) || this;
        _this.graphicsWithoutExplicitLabelPoints = function (graphics, dimensions) {
            var dimensionLookup = Dimension_1.getMapFromDimensions(dimensions);
            return graphics.filter(function (graphic) {
                var hasName = dimensionLookup[graphic.dimensionKey]
                    && dimensionLookup[graphic.dimensionKey].name.length > 0;
                var hasNoLabelPoint = !graphic.labelPoint;
                return hasName && hasNoLabelPoint;
            });
        };
        _this.calculateDefaultLabelPoints = function () {
            var _a = _this.props, graphics = _a.graphics, dimensions = _a.dimensions;
            var graphicsWithoutExplicitLabelPoints = _this.graphicsWithoutExplicitLabelPoints(graphics, dimensions);
            if (_this.svgRef.current) {
                var rect = _this.svgRef.current.getBoundingClientRect();
                var canvasHeight_1 = rect.height;
                var canvasWidth_1 = rect.width;
                var defaultMarginPX_1 = 25;
                var defaultLabelPoints_1 = {};
                graphicsWithoutExplicitLabelPoints.forEach(function (graphic) {
                    var x1 = graphic.start.xPercent / 100 * canvasWidth_1;
                    var y1 = graphic.start.yPercent / 100 * canvasHeight_1;
                    var x2 = graphic.end.xPercent / 100 * canvasWidth_1;
                    var y2 = graphic.end.yPercent / 100 * canvasHeight_1;
                    var coordinatePoint = graphics_1.calculateDefaultLabelPoint({ x: x1, y: y1 }, { x: x2, y: y2 }, defaultMarginPX_1);
                    var coordinatePointPercentX = coordinatePoint.x / canvasHeight_1 * 100;
                    var coordinatePointPercentY = coordinatePoint.y / canvasWidth_1 * 100;
                    defaultLabelPoints_1[graphic.uniqueKey] = {
                        xPercent: coordinatePointPercentX,
                        yPercent: coordinatePointPercentY,
                    };
                });
                return defaultLabelPoints_1;
            }
            return {};
        };
        _this.graphicId = function (graphic) { return "graphic-" + graphic.uniqueKey; };
        _this.getGraphicName = function (graphic, dimensionLookup) {
            return dimensionLookup[graphic.dimensionKey]
                && dimensionLookup[graphic.dimensionKey].name
                || "";
        };
        _this.getGraphicMeasurement = function (graphic, showMM) {
            var _a = _this.props, currentVariantId = _a.currentVariantId, sizingChart = _a.sizingChart, displayUnit = _a.displayUnit;
            var sizeChartDisplayUnit = sizingChart.unit;
            var relevantMeasurement = lodash_find_1.default(sizingChart.measurements, function (measurement) {
                // TODO(jeffk): switch off of this dimension
                var dimensionKeyMatches = measurement.dimensionKey === graphic.dimensionKey;
                var optionIdMatches = measurement.variantId === currentVariantId;
                return dimensionKeyMatches && optionIdMatches;
            });
            if (relevantMeasurement) {
                return size_chart_1.displayMeasurement(relevantMeasurement, sizeChartDisplayUnit, displayUnit, showMM);
            }
            return undefined;
        };
        _this.renderGraphics = function (labelFn) {
            return lodash_flatmap_1.default(_this.props.graphics, function (graphic) {
                var graphicId = _this.graphicId(graphic);
                var defaultLabelPoint = _this.state.defaultLabelPoints[graphic.uniqueKey];
                var labelPoint = graphic.labelPoint;
                var finalLabelPoint = labelPoint || defaultLabelPoint;
                var graphicText = labelFn(graphic);
                var graphicComponent = React.createElement(GraphicComponent_1.GraphicComponent, { key: graphicId, id: graphicId, start: graphic.start, end: graphic.end, color: graphic.color, labelText: graphicText, labelPoint: finalLabelPoint, showDragElements: false, fontSize: graphic.fontSize });
                if (finalLabelPoint && graphicText) {
                    return [graphicComponent];
                }
                return [];
            });
        };
        _this.svgRef = React.createRef();
        _this.state = {
            defaultLabelPoints: {},
        };
        return _this;
    }
    Annotations.prototype.render = function () {
        var _this = this;
        var graphicsSVG = [];
        var dimensionLookup = Dimension_1.getMapFromDimensions(this.props.dimensions);
        switch (this.props.displayState) {
            case AnnotationsDisplay.SHOW_LABELS: {
                graphicsSVG = this.renderGraphics(function (g) { return _this.getGraphicName(g, dimensionLookup); });
                break;
            }
            case AnnotationsDisplay.SHOW_MEASUREMENTS: {
                var showMM_1 = large_measurements_1.shouldShowMM(this.props.sizingChart, this.props.currentVariantId);
                graphicsSVG = this.renderGraphics(function (g) { return _this.getGraphicMeasurement(g, showMM_1); });
                break;
            }
            case AnnotationsDisplay.HIDE:
            default: {
                graphicsSVG = [];
            }
        }
        return React.createElement("svg", { className: "ma-annotations", ref: this.svgRef }, graphicsSVG);
    };
    Annotations.prototype.componentDidMount = function () {
        var defaultLabelPoints = this.calculateDefaultLabelPoints();
        this.setState({ defaultLabelPoints: defaultLabelPoints });
    };
    Annotations.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props, graphics = _a.graphics, dimensions = _a.dimensions, displayState = _a.displayState;
        var inexplicitGraphics = this.graphicsWithoutExplicitLabelPoints(graphics, dimensions);
        var hasInexplicitGraphics = inexplicitGraphics.length > 0;
        var graphicsChanged = !lodash_isequal_1.default(prevProps.graphics, this.props.graphics);
        var displayStateChanged = prevProps.displayState !== displayState;
        if (hasInexplicitGraphics && (graphicsChanged || displayStateChanged)) {
            var defaultLabelPoints = this.calculateDefaultLabelPoints();
            this.setState({ defaultLabelPoints: defaultLabelPoints });
        }
    };
    return Annotations;
}(React.PureComponent));
exports.Annotations = Annotations;
